<template>
  <step-wrapper space-between :class="{ 'smaller-padding' : image.src !== null }">
    <step-header :text="text" step="3" step-count="4" strong/>
    <content-wrapper type="big" class="add-photo__wrap">
      <label class="image">
        <div
          class="add-photo"
          :class="{ 'add-photo__img-prev' : image.src !== null }"
          @click="checkPrevent($event)"
          @dragover.prevent
          @drop="onDrop"
        >
          <p
            class="add-photo__inner add-photo__inner--mobile"
            v-html="addPhotoInnerTextMobile"
            v-if="!image.src"
          />
          <p
            class="add-photo__inner"
            v-html="addPhotoInnerText"
            v-if="!image.src"
          />
          <div
            @click.prevent
            v-if="image.src"
            class="image-preview"
          >
            <div
              class="remove"
              @click="deleteImage"
            >
              &times;
            </div>
            <img
              :src="image.src"
            >
          </div>
        </div>
        <input
          id="image"
          type="file"
          @change="e => onImageChange(e.target.files)"
          class="image__input"
          accept="image/*"
        >
      </label>
      <div class="add-photo__description">
        Pamiętaj! Dodając zdjęcie do naszej mapy potwierdzasz że jesteś jego autorem i masz do niego pełnię praw.
      </div>
    </content-wrapper>
    <content-wrapper type="small">
      <button-component
        fixed-width
        @click="goToNextStep"
      >
        {{ buttonText }}
      </button-component>
    </content-wrapper>
  </step-wrapper>
</template>

<script>
import store from '@/store'
import {mapState} from 'vuex'
import StepWrapper from '@/components/StepWrapper'
import ContentWrapper from '@/components/ContentWrapper'
import StepHeader from '@/components/StepHeader'
import TextInput from '@/components/TextInput'
import ButtonComponent from '@/components/Button'
import axios from 'axios'

export default {
  components: {
    StepWrapper,
    StepHeader,
    ContentWrapper,
    TextInput,
    ButtonComponent
  },
  data () {
    return {
      text: `
        Podaj zdjęcie miejsca <br> lub pomiń ten krok
      `,
      addPhotoInnerText: `
        <span style="text-decoration: underline">Dodaj</span> lub wrzuć plik
      `,
      addPhotoInnerTextMobile: `
        <span style="text-decoration: underline">Dodaj plik</span>
      `,
      image: {
        approved: false,
        src: null,
        file: {}
      }
    }
  },
  computed: {
    ...mapState({
      place: state => state.add.place
    }),
    buttonText () {
      return this.image.approved ? 'Dalej' : 'Pomiń'
    }
  },
  created () {
    if (this.checkImage()) {
      this.image.src = this.place.imageSrc
      this.image.approved = true
    } else {
      this.image.approved = false
      this.image.src = null
      this.image.file = {}
    }
  },
  methods: {
    goToNextStep () {
      if (this.image.file.size > 0) {
        this.uploadImage(this.image.file)
      }
      this.$router.push({ name: 'add-step-4' })
    },
    onDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      let files = e.dataTransfer.files
      this.onImageChange(files)
    },
    invalidExtension (filename) {
      const extension = filename.toLowerCase().split('.').pop()
      let allowedExtensions = ['jpg', 'jpeg', 'png', 'gif']
      return allowedExtensions.indexOf(extension) === -1
    },
    checkPrevent (event) {
      if (this.image.approved) {
        event.preventDefault()
      }
    },
    deleteImage () {
      this.image.src = null
      this.image.approved = false
      this.image.file = {}
    },
    onImageChange (files) {
      const file = files[0]
      const MAX_SIZE = 10 * 1024 * 1024 // 10MB
      if (file && file.size < MAX_SIZE) {
        if (this.invalidExtension(file.name)) {
          this.addPhotoInnerTextMobile = this.addPhotoInnerText = `
            Upss.. Niewłaściwy format pliku<br>
            <span style="text-decoration: underline">Spróbuj</span> ponownie
          `
        } else {
          this.image.approved = true
          this.image.src = URL.createObjectURL(file)
          this.image.file = file
        }
      } else {
        this.addPhotoInnerTextMobile = this.addPhotoInnerText = `
            Upss.. Maksymalny rozmiar pliku to 10MB<br>
            <span style="text-decoration: underline">Spróbuj</span> ponownie
        `
      }
    },
    uploadImage (file) {
      const fd = new FormData()
      fd.append('image', file, file.name)
      axios.post('/gallery/upload/', fd, {
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      }).then(response => {
        this.place.imageSrc = response.data.image
        this.place.image = response.data.id
        this.$router.push({ name: 'add-step-4' })
      }).catch(err => {
        console.error(err)
      })
    },
    checkImage () {
      let flag = false
      try {
        if (typeof this.place.imageSrc !== 'undefined') {
          flag = true
        } else {
          flag = false
        }
      } catch (e) {
        flag = false
      }
      return flag
    }
  },
  beforeRouteEnter (to, from, next) {
    const currentStep = store.getters.currentAddPlaceStep
    if (currentStep > 2) {
      next()
    } else {
      next({ name: `add-step-${ currentStep }` })
    }
  }
}
</script>
<style lang="scss" scoped>
  @include media-up(sm) {
    .smaller-padding {
      padding: 2% 0;
    }
  }

  .add-photo {
    border: 2px solid #fff;
    cursor: pointer;
    padding: 100px 0;
    margin: 0 auto 7px auto;
    position: relative;
    display: block;

    &__img-prev {
      border: none;
      max-height: 50vh;
      margin-top: 5vh;
      padding: 0 !important;
      display: flex;
      justify-content: center;
      cursor: default;
    }

    @media screen and (max-height: 749px) and (min-height: 701px) {
      padding: 60px 0;
    }
    @media screen and (max-height: 660px) and (min-height: 601px) {
      padding: 60px 0;
    }
    @media screen and (max-height: 565px) {
      padding: 60px 0;
    }
    @media screen and (max-height: 480px) {
      padding: 60px 0;
      margin-top: 10px;
    }

    @include media-down(sm) {
      padding: 0;
      border: none;
    }

    &__wrap {
      padding-right: 0 !important;
      @include media-down(sm) {
        padding: 0 .6em 0 3.5em !important;
      }
      @include media-up(md) {
        padding: 0 3.8em 0 5em !important;
      }
      @include media-down(md) {
        padding: 0 10px !important;
      }
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        padding-top: 60px !important;
      }
    }

    &__inner {
      text-transform: uppercase;
      text-align: center;
      font-weight: 600;
      @include media-down(sm) {
        display: none;
      }
      &--mobile {
        font-weight: 300;
        font-size: 18px;
        text-transform: uppercase;
        display: none;
        @include media-down(sm) {
          display: block;
        }
      }
    }

    &__description {
      text-align: center;
      letter-spacing: 0.01em;
      @include media-down(sm) {
        font-size: 14px;
      }
    }
  }

  .underline {
    text-decoration: underline;
  }

  .image {
    &__input {
      display: none;
    }
    &-preview {
      max-height: 50vh;
      max-width: 90vw;
      margin: 0;
      position: relative;

      .remove {
        color: #fff;
        cursor: pointer;
        position: absolute;
        right: 12px;
        font-weight: 600;
        text-shadow: rgb(73, 73, 73) 1px 0 0, rgb(73, 73, 73) 0.540302px 0.841471px 0, rgb(73,73,73) -0.416147px 0.909297px 0, rgb(73,73,73) -0.989992px 0.14112px 0, rgb(184, 184, 184) -0.653644px -0.756802px 0, rgb(184, 184, 184) 0.283662px -0.958924px 0, rgb(184, 184, 184) 0.96017px -0.279415px 0;
        font-size: 35px;
        @include media-down(sm) {
          font-size: 44px;
        }
      }

      img {
        display: block;
        margin: 0 auto;
        width: auto;
        height: auto;
        max-width: 50vw;
        max-height: 50vh;
        border: 2px solid #fff;
        @include media-up(lg) {
          max-width: 40vw;
        }
        @include media-down(md) {
          max-width: 70vw;
        }
        @include media-down(sm) {
          max-width: 90vw;
        }
        @media screen and (max-height: 480px) {
          max-height: 35vh;
        }
      }
    }
    &-preview:hover {
      cursor: default;
    }
  }

</style>



// WEBPACK FOOTER //
// src/containers/AddPlace/AddThirdStep.vue